module.exports = __webpack_public_path__ + "img/i.6e964480.png";